/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import './about.css'
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const about = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className=".container about_container">

        <div className="about_me">
          <div className="about_me_image">
          <DotLottieReact
            src="https://lottie.host/2a24e86d-50b8-4e41-8ef6-e1fc8ef6f818/3HXqGCpyKT.lottie"
            loop
            autoplay
          />
          </div>
        </div>

        <div className="about_content">
          <div className="about_cards">
            
          <article className='about_card'>
              <FaAward className='about_icon'/>
              <h5 className='reduce'>Experience</h5>
              <small>3+ Years Experience</small>
            </article>

            <article className='about_card'>
              <FiUsers className='about_icon'/>
              <h5>Clients</h5>
              <small>5+ Execellent Reviews</small>

            </article>
            <article className='about_card'>
              <VscFolderLibrary className='about_icon'/>
              <h5>Project</h5>
              <small>7+ compeleted projects</small>
            </article>
          </div>

          <p>
            I build scalable web applications, mobile solutions, and IoT systems with a strong interest in Artificial Intelligence and intelligent systems. I enjoy transforming ideas into practical, user-focused products that solve real-world challenges.
            My expertise spans web development, mobile app development, and IoT, and I am continually exploring new technologies that push the boundaries of innovation. I am also available for tutoring and mentorship, helping aspiring developers strengthen their technical skills and confidence in technology.

          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>

        </div>
      </div>

    </section>
  )
}

export default about
